import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
    API_BASE_URL,
    NETCASH_SERVICE_KEY,
    NETCASH_VENDOR_KEY,
} from '../../../config/config';
import { PaymentClient, CampaignClient } from '../../../services/apiClient';
import axiosInstance from '../../../services/axiosInstance';
import Loader from '../../../components/common/Loader';
import SimpleAlert from '../../../components/common/SimpleAlert';

const DebitOrderRedirect = () => {
    const { campaignId } = useParams();
    const [backgroundImage, setBackgroundImage] = useState<string | null>(null);
    const campaignClient = new CampaignClient(API_BASE_URL, axiosInstance);

    const getImageSas = async () => {
        try {
            if (campaignId) {
                const response =
                    await campaignClient.generateCampaignImageSas(campaignId);
                if (response && response.success) {
                    setBackgroundImage(response.data ?? '');
                }
            }
        } catch (error) {
            console.error('Error fetching campaign image:', error);
        }
    };

    useEffect(() => {
        getImageSas();
    }, [campaignId]);

    return (
        <div
            className="w-full h-screen flex items-center justify-center relative"
            style={{ backgroundImage: `url(${backgroundImage})` }}
        >
            <div className="absolute top-0 left-0 w-full h-full bg-black opacity-50 z-0" />
            <div className="z-10 bg-white rounded-lg shadow-lg p-6 w-full max-w-md text-center">
                <img src="/images/logo.png" className="mx-auto mb-6 w-40" />
                <div className="text-gray-700 text-lg font-semibold">
                    Thank You For Supporting SUCo!
                </div>
            </div>
        </div>
    );
};

export default DebitOrderRedirect;
